const { LOG_LEVEL } = process.env;

export default {
  log: (message, isLoggingEnabled) => {
    if (isLoggingEnabled && LOG_LEVEL >= 3) {
      console.info(message);
    }
  },
  warning: (message, isLoggingEnabled) => {
    if (isLoggingEnabled && LOG_LEVEL >= 2) {
      console.warn(message);
    }
  },
  error: (message, isLoggingEnabled) => {
    console.log(isLoggingEnabled, ' ', LOG_LEVEL);
    if (isLoggingEnabled && LOG_LEVEL >= 1) {
      console.error(message);
    }
  },
};



// WEBPACK FOOTER //
// ./src/services/logger.js